import React from "react";
import moment from "moment";
import { Translation } from "../../core/translate";
import { Stopwatch } from "@vitalsource/vstui-icons";
import { RedStopwatch } from "./book/red-stopwatch";

export const expirationMessage = book => {
  if (
    !book ||
    !book.intendedUses ||
    book.intendedUses.indexOf("vst store") === -1
  ) {
    return { Icon: null, label: null };
  }
  const duration = moment.duration(
    new Date(book.expiresAt) - new Date(),
    "milliseconds"
  );
  const hours = parseInt(duration.asHours());
  if (hours < 24) {
    return {
      Icon: RedStopwatch,
      label: <Translation id="library.expires-in-hours" hours={hours} />
    };
  }
  const days = parseInt(duration.asDays());
  if (days < 7) {
    return {
      Icon: RedStopwatch,
      label: <Translation id="library.loan-expiry-days" days={days} />
    };
  }
  if (days < 365) {
    return {
      Icon: Stopwatch,
      label: <Translation id="library.loan-expiry-days" days={days} />
    };
  }
  return { Icon: null, label: null };
};
